import { Controller } from "@hotwired/stimulus";

/**
 * Close Drawer Controller
 *
 * Simple controller that closes the drawer when connected.
 * Used after successful form submission to automatically close the drawer.
 */
export default class extends Controller {
  connect() {
    // Find the drawer controller and close it
    const drawerElement = this.element.closest('[data-controller~="drawer"]');

    if (drawerElement) {
      // Trigger the close action on the drawer
      const closeButton = drawerElement.querySelector('[data-action="drawer#close"]');
      if (closeButton) {
        closeButton.click();
      } else {
        // Fallback: manually hide the drawer
        const container = drawerElement.querySelector('[data-drawer-target="container"]');
        if (container) {
          container.classList.add('hidden');
          document.body.classList.remove('overflow-hidden');
        }
      }
    }
  }
}
